module.exports = __webpack_public_path__ + "img/yes.bb3a3df0.png";